import useSWR from "swr";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { EditionDetail, EditionKind } from "../types";

interface UseEditionDetailResult {
  detail?: EditionDetail;
  isLoading: boolean;
  error: any;
  mutate: () => void;
}

export const useEditionDetail = (
  corporateId: string | number,
  editionId: string | number,
  kind: EditionKind,
): UseEditionDetailResult => {
  const url =
    corporateId && editionId
      ? `${ServicesURL.getEditionsDetail}/${kind}/${editionId}?corporateId=${corporateId}`
      : null;

  const { data, isLoading, error, mutate } = useSWR(url, (u: string) =>
    fetcher<EditionDetail>(u, MethodType.GET),
  );

  return {
    detail: data,
    isLoading,
    error,
    mutate,
  };
};
